import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { api_url } from '../../constant/constant';
import { showToast } from '../../Components/ShowToast/ToastNotification';

const PhishingEmailLog = ({ id }) => {
  const [emailLogs, setEmailLogs] = useState([]);
  const [error, setError] = useState('');
  const [isSending, setIsSending] = useState(false);
  const { t } = useTranslation();
  // const [searchVal, setSearchVal] = useState('');
  const [links, setLinks] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [data, setUser] = useState([]);

  const handleSendEmail = async (campaignId) => {
    setIsSending(true);
    try {
      const token = localStorage.getItem('userToken');
      const response = await fetch(
        `${api_url}/phishing-campaign-settings/${campaignId}/send-emails`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const result = await response.json();
      if (response.ok) {
        showToast(t('emailsentsuccessfully'), 'success');
        fetchEmaillog();
      } else {
        showToast(t('failetosendemail'), 'error');
      }
    } catch (error) {
      console.error('Error sending email:', error);
      showToast(t('anerroroccurredwhilesendingtheemail'), 'error');
    } finally {
      setIsSending(false); // ✅ Stop loader
    }
  };

  useEffect(() => {
    if (searchValue !== '') {
      const searchText = searchValue?.toLowerCase() || '';
      const filteredData = data.data?.filter(
        (item) =>
          item?.username?.toLowerCase().includes(searchText) ||
          item?.email?.toLowerCase().includes(searchText) ||
          item?.status?.toLowerCase().includes(searchText) ||
          item?.sent_time?.toLowerCase().includes(searchText),
      );
      setEmailLogs(filteredData); // ✅ Update the display data
    } else {
      fetchEmaillog();
    }
  }, [searchValue]);

  const fetchEmaillog = async (customUrl = null) => {
    try {
      const token = localStorage.getItem('userToken');
      const apiUrl = customUrl || `${api_url}/phishing-campaigns/${id}/logs`;

      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      setEmailLogs(result.data.data || []);
      setLinks(result.data.links || []);
      setUser(result.data || []); // ✅ needed for search to work
    } catch (error) {
      console.error('Error fetching email logs:', error);
      setError(t('errorFetchingEmailLogs'));
    }
  };

  useEffect(() => {
    fetchEmaillog();
  }, [id]);

  return (
    <div className='container mt-4'>
      <div className='primaryBlueBox pad mb-4'>
        <div className='row'>
          <div className='col-md-4'>
            <label className='form-label'>{t('SearchPhishingCampaignEmailLog')}</label>
            <div className='input-group'>
              <input
                type='text'
                className='form-control'
                placeholder={t('Searchbyname')}
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
              />

              <button className='btn btn-outline-secondary btnSearchIcon' type='button'>
                <i className='bi bi-search'></i>
              </button>
            </div>
          </div>
          <div className='col-md-1'>
            <div className='vrLine'></div>
          </div>
          <div className='col-md-7 col-12'>
            <button
              className='btnWhiteGradient mt-4'
              onClick={(e) => {
                e.stopPropagation();
                handleSendEmail(id);
              }}
              style={{
                backgroundColor: 'gray',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                marginTop: '30px',
              }}
              disabled={isSending}
            >
              {isSending ? (
                <span
                  className='spinner-border spinner-border-sm me-2'
                  role='status'
                  aria-hidden='true'
                ></span>
              ) : (
                <i className='bi bi-envelope me-2 h6'></i>
              )}
              {t('SendEmail')}
            </button>
          </div>
        </div>
      </div>

      <h2>{t('EmailLogs')}</h2>

      <div className='table-responsive'>
        <table className='table table-striped'>
          <thead>
            <tr>
              <th>{t('Username')}</th>
              <th>{t('Email')}</th>
              <th>{t('Status')}</th>
              <th>{t('senttime')}</th>
            </tr>
          </thead>
          <tbody>
            {emailLogs.length > 0 ? (
              emailLogs.map((log) => (
                <tr key={log.id}>
                  <td>{log.username}</td>
                  <td>{log.email}</td>
                  <td>{log.status}</td>
                  <td>{log.sent_time}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan='4' className='text-center'>
                  {t('NoEmailLogsFound')}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className='navigationWrapper'>
        <ul>
          {links.map((link, index) => (
            <li
              key={index}
              className={`${link.active ? 'active' : ''} ${
                link.url === null ? 'disabled' : ''
              }`}
              onClick={link.url !== null ? () => fetchEmaillog(link.url) : undefined}
            >
              <div dangerouslySetInnerHTML={{ __html: link.label }} />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default PhishingEmailLog;
